import { useEffect, useState, useCallback } from "react";
import Header from "../../Components/Header";
import LoadingInComponent from "../../Components/LoadingInComponent";
import axios from "axios";
import {
  EXPORT_GUEST_API,
  EXPORT_IMPORT_TEMPLATE_API,
  LE_EVENT_INFO_API,
  LE_GUEST_ADD_API,
  LE_GUEST_DELETE_API,
  LE_GUEST_EDIT_API,
  LE_GUEST_IMPORT_API,
  LE_GUEST_LIST_API,
} from "../../Constant/api";
import { useToast } from "../../Components/Toast";
import Button from "../../Components/Button";
import {
  ArrowLeft,
  DocumentDownload,
  Import,
  Link21,
  UserAdd,
  Warning2,
} from "iconsax-react";
import { useNavigate } from "react-router-dom";
import { LOW_END_CHECKIN, LOW_END_EVENT_INFO } from "../../Router/path";
import LEGuestListTable from "../../Components/Tables/LEGuestListTable";
import PhoneInput from "react-phone-input-2";
import Modal from "../../Components/Modal";
import TextboxSet from "../../Components/TextboxSet";
import fileDownload from "js-file-download";
import FileUpload from "../../Components/FileUpload";

const LEGuestList = () => {
  const [loading, setLoading] = useState(false);
  const [guestList, setGuestList] = useState(null);
  const [recordedPage, setRecordedPage] = useState(1);
  const [guestListMeta, setGuestListMeta] = useState(null);
  const [guestForm, setGuestForm] = useState({
    first_name: "",
    last_name: "",
    email: "",
    contact: "",
    le_table: "",
  });
  const [eventInfo, setEventInfo] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState("add");
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [guestToDelete, setGuestToDelete] = useState(null);
  const [showFileUploadModal, setShowFileUploadModal] = useState(false);

  const navigate = useNavigate();
  const { toast } = useToast();

  const fetchEventInfo = useCallback(() => {
    setLoading(true);
    axios
      .get(LE_EVENT_INFO_API, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("bearer_token")}`,
        },
        params: { event_id: sessionStorage.getItem("event_id") },
      })
      .then((response) => {
        setEventInfo(response.data.data);
        setLoading(false);
      })
      .catch((error) => {
        toast(
          error.response?.data?.message || "Failed to fetch event details",
          "error",
        );
        console.error("Error fetching event details:", error);
        setLoading(false);
      });
  }, [toast]);

  const fetchGuestList = useCallback((page = 1) => {
    setLoading(true);
    axios
      .get(LE_GUEST_LIST_API, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("bearer_token")}`,
        },
        params: {
          event_id: sessionStorage.getItem("event_id"),
          search: searchTerm,
          page: page,
        },
      })
      .then((response) => {
        setGuestList(response.data.data);
        setGuestListMeta(response.data.meta.pagination);
        setLoading(false);
      })
      .catch((error) => {
        toast(
          error.response?.data?.message || "Failed to fetch guest list",
          "error",
        );
        console.error("Error fetching guest list:", error);
        setLoading(false);
      });
  }, [searchTerm, toast]);

  const createGuest = () => {
    setLoading(true);
    axios
      .post(LE_GUEST_ADD_API, guestForm, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("bearer_token")}`,
        },
        params: { event_id: sessionStorage.getItem("event_id") },
      })
      .then((response) => {
        toast("Guest added successfully", "success");
        setShowModal(false);
        fetchGuestList(recordedPage);
        setGuestForm({
          first_name: "",
          last_name: "",
          email: "",
          contact: "",
          le_table: "",
        });
        setLoading(false);
      })
      .catch((error) => {
        toast(error.response?.data?.message || "Failed to add guest", "error");
        console.error("Error adding guest:", error);
        setLoading(false);
      });
  };

  const handleEditClick = (guest_id) => {
    setModalType("edit");
    setGuestForm({
      ...guestList.find((guest) => guest.id === guest_id),
    });
    setShowModal(true);
  };

  const handleEditGuest = () => {
    console.log("Editing guest with data:", guestForm);
    setLoading(true);
    axios
      .put(LE_GUEST_EDIT_API, guestForm, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("bearer_token")}`,
        },
        params: { event_id: sessionStorage.getItem("event_id") },
      })
      .then((response) => {
        toast("Guest updated successfully", "success");
        setShowModal(false);
        fetchGuestList(recordedPage);
        setGuestForm({
          first_name: "",
          last_name: "",
          email: "",
          contact: "",
          le_table: "",
        });
        setLoading(false);
      })
      .catch((error) => {
        toast(
          error.response?.data?.message || "Failed to update guest",
          "error",
        );
        console.error("Error updating guest:", error);
        setLoading(false);
      });
  };

  const handleDeleteGuest = () => {
    axios
      .delete(LE_GUEST_DELETE_API, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("bearer_token")}`,
        },
        params: { id: guestToDelete },
      })
      .then((response) => {
        setLoading(false);
        fetchGuestList(recordedPage);
        setShowConfirmationModal(false);
        toast("Guest deleted successfully", "success");
      });
  };

  const exportGuestList = async () => {
    toast("Exporting guest list...", "info");
    axios
      .post(
        EXPORT_GUEST_API,
        { eventId: sessionStorage.getItem("event_id"), isLowEnd: true },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("bearer_token")}`,
            TimezoneOffset: new Date().getTimezoneOffset(),
          },
          responseType: "blob",
        },
      )
      .then((res) => {
        fileDownload(res.data, "guest_list.xlsx");
      })
      .catch((err) => {
        toast("Failed to fetch guest list template.", "error");
        console.log(err);
      });
  };

  const downloadLowEndGuestTemplate = async () => {
    toast("Downloading import template...", "info");
    axios
      .post(
        EXPORT_IMPORT_TEMPLATE_API,
        { eventId: sessionStorage.getItem("event_id"), isLowEnd: true },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("bearer_token")}`,
            TimezoneOffset: new Date().getTimezoneOffset(),
          },
          responseType: "blob",
        },
      )
      .then((res) => {
        fileDownload(res.data, "import_template.xlsx");
      })
      .catch((err) => {
        toast("Failed to fetch import template.", "error");
        console.log(err);
      });
  };

  const handleImportGuestList = (data) => {
    setLoading(true);
    axios
      .post(
        LE_GUEST_IMPORT_API,
        { filePath: data.url, eventId: sessionStorage.getItem("event_id") },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("bearer_token")}`,
          },
        },
      )
      .then((res) => {
        setLoading(false);
        toast("Guest list imported successfully", "success");
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        toast("Failed to import", "error");
      });
  };

  const handlePageClick = (e) => {
    setRecordedPage(e.selected + 1);
    fetchGuestList(e.selected + 1);
  };

  useEffect(() => {
    fetchEventInfo();
    fetchGuestList();
  }, [fetchEventInfo, fetchGuestList]);

  return (
    <div className="flex flex-col w-full min-h-screen">
      <Header noSidebar={true} />

      {showConfirmationModal && (
        <Modal
          title="Delete Guest"
          confirmation={handleDeleteGuest}
          toggleModal={() => setShowConfirmationModal(!showConfirmationModal)}
          submitLabel="Delete"
        >
          <div className="flex flex-col w-full items-center justify-center gap-[16px] py-[32px]">
            <Warning2 size="64" color="#ff0000" variant="Bold" />
            <p>Are you sure you want to delete this guest?</p>
          </div>
        </Modal>
      )}

      {showFileUploadModal && (
        <Modal
          title="Import Guest List"
          description="Import a .xlsx or .csv format file."
          toggleModal={() => setShowFileUploadModal(!showFileUploadModal)}
        >
          <FileUpload handleChange={handleImportGuestList} lowEndMode={true} />
        </Modal>
      )}

      {showModal && (
        <Modal
          title={modalType === "add" ? "Add Guest" : "Edit Guest"}
          toggleModal={() => {
            setGuestForm({
              first_name: "",
              last_name: "",
              email: "",
              contact: "",
              le_table: "",
            });
            setShowModal(!showModal);
          }}
          loading={loading}
          submitLabel={modalType === "add" ? "Add Guest" : "Edit Guest"}
          handleSubmit={modalType === "add" ? createGuest : handleEditGuest}
        >
          <div className="grid grid-cols-1 md:grid-cols-2 w-full h-full gap-[24px]">
            <TextboxSet
              onChange={(e) =>
                setGuestForm((prev) => ({
                  ...prev,
                  first_name: e.target.value,
                }))
              }
              value={guestForm.first_name}
              type="text"
              label="First Name"
              placeholder="First Name"
              name="first_name"
              required
            />
            <TextboxSet
              onChange={(e) =>
                setGuestForm((prev) => ({ ...prev, last_name: e.target.value }))
              }
              value={guestForm.last_name}
              type="text"
              label="Last Name"
              placeholder="Last Name"
              name="last_name"
              required
            />
            <TextboxSet
              onChange={(e) =>
                setGuestForm((prev) => ({ ...prev, email: e.target.value }))
              }
              type="email"
              label="Email"
              name="email"
              placeholder="Email"
              value={guestForm.email}
            />
            <div className="flex flex-col w-full gap-[6px]">
              <h2>Contact Number</h2>
              <PhoneInput
                country={"my"}
                value={guestForm.contact}
                inputStyle={{
                  width: "100%",
                  height: "38px",
                  borderRadius: "8px",
                  fontSize: "14px",
                  borderColor: "#EFF0F2",
                }}
                buttonStyle={{
                  borderRadius: "8px",
                  borderColor: "#EFF0F2",
                }}
                onChange={(phone) =>
                  setGuestForm((prev) => {
                    return { ...prev, contact: phone };
                  })
                }
              />
            </div>
            <div className="col-span-1 md:col-span-2">
              <TextboxSet
                onChange={(e) =>
                  setGuestForm((prev) => ({
                    ...prev,
                    le_table: e.target.value,
                  }))
                }
                type="text"
                label="Table"
                name="le_table"
                placeholder="Table"
                value={guestForm.le_table}
              />
            </div>
          </div>
        </Modal>
      )}

      <LoadingInComponent isLoading={loading}>
        <div className="flex flex-col w-full h-fit min-h-[calc(70%)] lg:px-[128px] items-center p-[16px] md:p-[32px] gap-[16px] md:gap-[32px] bg-[#F7F8F9]">
          {/* title and buttons */}
          {eventInfo && (
            <div className="flex flex-col w-full justify-center items-center gap-2">
              <h1 className="text-[29px]">{eventInfo.name}</h1>
              <div className="flex flex-col items-center justify-center">
                <p className="text-[#666666]">
                  {eventInfo.date ?? "No Date Set"}
                </p>
                <p className="text-[#666666]">
                  {eventInfo.time ?? "No Time Set"}
                </p>
                <p className="text-[#666666]">
                  {eventInfo.venue ?? "No Venue Set"}
                </p>
              </div>
            </div>
          )}
          {eventInfo && (
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 w-full items-center justify-center gap-2">
              <Button
                variant="secondary"
                onClick={() => navigate(LOW_END_EVENT_INFO)}
                disabled={loading}
              >
                <ArrowLeft size="20" />
                Back to Event
              </Button>
              <Button
                disabled={loading}
                onClick={() => setShowFileUploadModal(true)}
              >
                <Import size="20" />
                Import
              </Button>
              <Button disabled={loading} onClick={downloadLowEndGuestTemplate}>
                <DocumentDownload size="20" />
                Import Template
              </Button>
              <Button disabled={loading} onClick={exportGuestList}>
                <DocumentDownload size="20" />
                Download List
              </Button>
              <Button
                disabled={loading}
                onClick={() => {
                  window.open(
                    `${LOW_END_CHECKIN}?event_id=${eventInfo.id}`,
                    "_blank",
                  );
                }}
              >
                <Link21 size="20" />
                View Live Site
              </Button>
              <Button
                onClick={() => {
                  setShowModal(true);
                  setModalType("add");
                }}
                disabled={loading}
              >
                <UserAdd size="20" />
                Add Guest
              </Button>
            </div>
          )}

          {/* Table */}
          {guestList && (
            <LEGuestListTable
              data={guestList}
              meta={guestListMeta}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              handleEditClick={handleEditClick}
              handlePageClick={handlePageClick}
              handleDeleteClick={(guestId) => {
                setShowConfirmationModal(true);
                setGuestToDelete(guestId);
              }}
            />
          )}
        </div>
      </LoadingInComponent>
    </div>
  );
};

export default LEGuestList;
